/**
 * Custom hook for loading programs from the database
 * Uses React Query for automatic caching and deduplication
 */
import { useQuery } from '@tanstack/react-query';
import { getPrograms, Program } from '../services/programsService';

export type { Program };

/**
 * Hook for loading active programs
 * Uses React Query with long stale time since programs rarely change
 */
export function usePrograms() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['programs'],
    queryFn: getPrograms,
    staleTime: 30 * 60 * 1000, // 30 minutes
    gcTime: 60 * 60 * 1000, // 1 hour
    refetchOnWindowFocus: false,
  });

  return {
    programs: data || [],
    loading: isLoading,
    error: error ? (error instanceof Error ? error.message : 'Failed to load programs') : null,
  };
}
